import { render, staticRenderFns } from "./TeamProfile.vue?vue&type=template&id=6b5e4ac6&scoped=true"
import script from "./TeamProfile.vue?vue&type=script&lang=js"
export * from "./TeamProfile.vue?vue&type=script&lang=js"
import style0 from "./TeamProfile.vue?vue&type=style&index=0&id=6b5e4ac6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e4ac6",
  null
  
)

export default component.exports